import { render, staticRenderFns } from "./extension.vue?vue&type=template&id=7758902e&scoped=true"
import script from "./extension.vue?vue&type=script&lang=js"
export * from "./extension.vue?vue&type=script&lang=js"
import style0 from "./extension.vue?vue&type=style&index=0&id=7758902e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7758902e",
  null
  
)

export default component.exports